<ng-container
  *ngIf="
    !isSiteIntl && (!loginRequired || isLoggedIn) && isShowDownload;
    else disabledLink
  "
>
  <div edsPadding [edsPaddingTop]="(isMobile$ | async) ? 'sm' : ''">
    <p class="spacing--none ag-cell-fund-name">
      <eds-title
        *ngIf="componentName !== 'fundDocumentListing'"
        [size]="isLargeDesktop ? 'h4' : 'h6'"
        [title]="fundName"
        [theme]="'primary'"
        class="ag-cell-frk--link"
        [href]="fundLink"
        [isNewWindow]="true"
        (click)="onLinkClick($event)"
      ></eds-title>

      <ng-container *ngIf="componentName === 'fundDocumentListing'">
        {{ fundName }}</ng-container
      >
    </p>
    <p class="truncate" *ngIf="componentName !== 'fundDocumentListing'">
      {{ details }}
    </p>
    <div *ngIf="showUpdateNotification" edsFlexbox edsSpacing="none">
      <eds-icon
        type="alert"
        size="small"
        edsPadding
        edsPaddingLeft="xs"
      ></eds-icon>
      <span edsPadding edsPaddingLeft="xs" class="ag-cell-frk--link">{{
        updateNotificationMessage
      }}</span>
    </div>
  </div>
</ng-container>
<ng-template #disabledLink>
  <eds-title
    *ngIf="!isSiteIntl && componentName !== 'fundDocumentListing'"
    [size]="isLargeDesktop ? 'h4' : 'h6'"
    [title]="fundName"
  ></eds-title>
  <p
    class="truncate"
    *ngIf="componentName !== 'fundDocumentListing' && !isSiteIntl"
  >
    {{ details }}
  </p>
  <p
    *ngIf="componentName === 'fundDocumentListing' || isSiteIntl"
    class="spacing--none ag-cell-fund-name"
  >
    {{ fundName }}
  </p>
</ng-template>
